import React from "react";
import styles from "../EventsPage.module.css";

export function EventsSectionHeader({
  title,
  description,
  descriptionTone = "upcoming",
  className = "",
  headingId,
}) {
  const descClass =
    descriptionTone === "previous" ? styles.sectionDescriptionPrevious : styles.sectionDescription;
  return (
    <div className={`${styles.sectionHeader} ${className}`.trim()}>
      <h2 id={headingId} className={styles.sectionTitle}>
        {title}
      </h2>
      {description ? <p className={descClass}>{description}</p> : null}
    </div>
  );
}
